__turbopack_context__.v({
  "app_light_theme": "slider-pagination-detailed-module-scss-module__1dyjva__app_light_theme",
  "pagination": "slider-pagination-detailed-module-scss-module__1dyjva__pagination",
  "pagination__container": "slider-pagination-detailed-module-scss-module__1dyjva__pagination__container",
  "pagination__el": "slider-pagination-detailed-module-scss-module__1dyjva__pagination__el",
  "pagination__elContainer": "slider-pagination-detailed-module-scss-module__1dyjva__pagination__elContainer",
  "pagination__elContainer__active": "slider-pagination-detailed-module-scss-module__1dyjva__pagination__elContainer__active",
  "pagination__video": "slider-pagination-detailed-module-scss-module__1dyjva__pagination__video",
  "pagination__videoPlay": "slider-pagination-detailed-module-scss-module__1dyjva__pagination__videoPlay",
});
